import { search } from 'shared/models/api';
import { debounce } from 'shared/utils';
import { track } from 'shared/models/analytic';

export const AUTOCOMPLETE = 'AUTOCOMPLETE';
export const CLEAR = 'CLEAR';
export const UPDATE_INPUT = 'UPDATE_INPUT';

const init = { value: '', suggestions: [] };

export default function(state = init, action = {}) {
  switch (action.type) {
    case AUTOCOMPLETE:
      return { ...state, suggestions: action.result };
    case UPDATE_INPUT:
      return { ...state, value: action.value };
    case CLEAR:
      return init;
    default:
      return state;
  }
}

let _currentSearch;
const debouncedSearch = debounce((dispatch, value) => {
  if (_currentSearch && _currentSearch.isPending()) _currentSearch.cancel();

  _currentSearch = search(value).then(res => {
    const filters = (res.filters || [])
      .map(filter => ({ ...filter, recommendationType: 'filter' }));
    const products = (res.products || [])
      .map(product => ({ ...product, recommendationType: 'product' }));
    const result = filters.concat(products);

    dispatch({ type: AUTOCOMPLETE, result });

    if (value.length > 3) track('Products Searched', { query: value });
  });

  return _currentSearch;
}, 500);

export function autocomplete(value) {
  return dispatch => debouncedSearch(dispatch, value);
}

export function updateInput(value) {
  return dispatch => dispatch({ type: UPDATE_INPUT, value: value });
}

export function clearSuggestion() {
  return dispatch => dispatch({ type: CLEAR });
}



// WEBPACK FOOTER //
// ./shared/components/search/actions.js